import './BridgeBioMaterialCode.scss';

import classNames from 'classnames';

import { BRIDGE_BIO_MATERIAL_CODE } from '@constants/bridgeBio';

export interface BridgeBioMaterialCodeProps {
  className?: string;
}

export function BridgeBioMaterialCode(props: BridgeBioMaterialCodeProps) {
  const { className } = props;

  return <p className={classNames('bridge-bio-material-code', className)}>{BRIDGE_BIO_MATERIAL_CODE}</p>;
}
